import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';

import { DocutechGlobalModel } from '../../models/docutech-global.model';
import { DocutechGlobalStore } from './docutech-global.store';

@Injectable({ providedIn: 'root' })
export class DocutechGlobalQuery extends Query<DocutechGlobalModel> {
  protected store: DocutechGlobalStore;

  constructor() {
    const store = inject(DocutechGlobalStore);

    super(store);

    this.store = store;
  }
}
